import * as actionTypes from '../actions/actionTypes'

const initialState = {
  records: [],
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 0,
    lastPage: 0,
    from: 0,
    to: 0
  },
  appraisalTypes: [],
  filtered: false,
  filterLoading: [],
  filterCompanies: [],
  filterForms: [],
  filterOrgs: [],
  filterData: [],
  gradeData: [],
  filterLoadingQueue: [],
  loading: false,
  data: [],
  total: null,
  adjustData: []
}

// FETCH_APPRAISAL_TYPE_OPTION

// START
const fetchAppraisalTypeOptionsStart = (state, action) => {
  return {
    ...state
  }
}

// SUCCESS
const fetchAppraisalTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    appraisalTypes: action.data.map(item => {
      return {
        appraisal_type_id: item.value_list_id,
        appraisal_type_code: item.value_list_code,
        appraisal_type_name: item.value_list_name
      }
    })
  }
}

// FAILED
const fetchAppraisalTypeOptionsFailed = (state, action) => {
  return {
    ...state
  }
}

// FETCH_COMPANY_OPTION

// START
const fetchCompanyOptionsStart = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: [...state.filterLoadingQueue, 'company_id']
  }
}

// SUCCESS
const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id'),
    filterCompanies: action.data
  }
}

// FAILED
const fetchCompanyOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id')
  }
}

// FETCH_FORM_OPTION

// START
const fetchFormOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'form_id'] }
}

// SUCCESS
const fetchFormOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterForms: action.data,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
  }
}

// FAILED
const fetchFormOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
  }
}

// FETCH_ORGANIZATION_OPTION

// START
const fetchForcedOrganizationOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'org_id'] }
}

// SUCCESS
const fetchForcedOrganizationOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterOrgs: action.data,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id')
  }
}

// FAILED
const fetchForcedOrganizationOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id')
  }
}

const fetchForceRankFilterStart = (state, action) => {
  return {
    ...state,
    filterLoading: true
  }
}

const fetchForceRankFilterSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    // filtered: true,
    filterData: action.data,
    pagination: action.pagination,
    total: action.total,
    adjustData: {
      ...state.adjustData,
      force_rank_budget: [],
      result_header: {}
    },
    data: {}
  }
}

const fetchForceRankFilterFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    // filtered: true
  }
}

const fetchForceRankGradeStart = (state, action) => {
  return {
    ...state,
    // filtered: true
  }
}

const fetchForceRankGradeSuccess = (state, action) => {
  return {
    ...state,
    // filtered: true,
    gradeData: action.data
  }
}

const fetchForceRankGradeFailed = (state, action) => {
  return {
    ...state,
    // filtered: false,
    message: action.errorMessage
  }
}

const fetchForceRankListStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchForceRankListSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    data: action.data
  }
}

const fetchForceRankListFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchForceRankCalculateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchForceRankCalculateSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    data: action.data
  }
}

const fetchForceRankCalculateFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const createForceRankStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const createForceRankSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createForceRankFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchAdjustStart = (state, action) => {
  return {
    ...state,
    filterLoading: true
  }
}

const fetchAdjustSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterData: action.data,
    pagination: action.pagination,
    total: action.total,
    adjustData: action.adjustData
  }
}

const fetchAdjustFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

// REDUCER
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH_APPRAISAL_TYPE_OPTION
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, action)

    // FETCH_COMPANY_OPTIONS
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
      return fetchCompanyOptionsStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCompanyOptionsFailed(state, action)

    // FETCH_FORM_OPTIONS
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormOptionsStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormOptionsSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormOptionsFailed(state, action)

    // FETCH_ORGANIZATION_OPTIONS
    case actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchForcedOrganizationOptionsStart(state, action)
    case actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchForcedOrganizationOptionsSuccess(state, action)
    case actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchForcedOrganizationOptionsFailed(state, action)

    // FETCH_FORCERANK_FILTER
    case actionTypes.FETCH_FORCERANK_FILTER_START:
      return fetchForceRankFilterStart(state, action)
    case actionTypes.FETCH_FORCERANK_FILTER_SUCCESS:
      return fetchForceRankFilterSuccess(state, action)
    case actionTypes.FETCH_FORCERANK_FILTER_FAILED:
      return fetchForceRankFilterFailed(state, action)

    // FETCH_FORCERANK_GRADE
    case actionTypes.FETCH_GRADE_OPTIONS_START:
      return fetchForceRankGradeStart(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_SUCCESS:
      return fetchForceRankGradeSuccess(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_FAILED:
      return fetchForceRankGradeFailed(state, action)

    // FETCH_FORCERANK_LIST
    case actionTypes.FETCH_FORCERANK_LIST_START:
      return fetchForceRankListStart(state, action)
    case actionTypes.FETCH_FORCERANK_LIST_SUCCESS:
      return fetchForceRankListSuccess(state, action)
    case actionTypes.FETCH_FORCERANK_LIST_FAILED:
      return fetchForceRankListFailed(state, action)

    // FETCH_FORCERANK_LIST
    case actionTypes.FETCH_FORCERANK_CALCULATE_START:
      return fetchForceRankCalculateStart(state, action)
    case actionTypes.FETCH_FORCERANK_CALCULATE_SUCCESS:
      return fetchForceRankCalculateSuccess(state, action)
    case actionTypes.FETCH_FORCERANK_CALCULATE_FAILED:
      return fetchForceRankCalculateFailed(state, action)

    case actionTypes.CREATE_FORCERANK_START:
      return createForceRankStart(state, action)
    case actionTypes.CREATE_FORCERANK_SUCCESS:
      return createForceRankSuccess(state, action)
    case actionTypes.CREATE_FORCERANK_FAILED:
      return createForceRankFailed(state, action)

    // FETCH_ADJUST
    case actionTypes.FETCH_ADJUST_START:
      return fetchAdjustStart(state, action)
    case actionTypes.FETCH_ADJUST_SUCCESS:
      return fetchAdjustSuccess(state, action)
    case actionTypes.FETCH_ADJUST_FAILED:
      return fetchAdjustFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    // DEFAULT
    default:
      return state
  }
}

export default reducer
